import styled from "styled-components";

export const DashboardContainer = styled.div`
  margin: 72px 10% 72px 10%;
`;
